var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-tooltip", { attrs: { variant: "danger", target: _vm.target } }, [
    _vm._v("Sorry, you don't have permission to do this action"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }